import React, { useRef, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const PromoSlider = ({ slides = [], speed = 3000 }) => {
    const sliderRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (!slides.length) return;

        const slider = sliderRef.current;
        let index = 0;

        const interval = setInterval(() => {
            index = (index + 1) % slides.length;
            setCurrentIndex(index); // update dot
            slider.scrollTo({
                left: index * slider.offsetWidth,
                behavior: "smooth",
            });
        }, speed);

        return () => clearInterval(interval);
    }, [slides, speed]);

    if (!slides.length) return null;

    return (
        <div style={{ position: "relative", width: "100%" }}>
            {/* Slider */}
            <div
                ref={sliderRef}
                style={{
                    display: "flex",
                    overflowX: "hidden",
                    width: "100%",
                    scrollSnapType: "x mandatory",
                    background: "#f6fbff",
                }}
            >
                {slides.map((slide) => {
                    const Image = (
                        <div
                            style={{
                                maxWidth: 420,
                                width: "100%",
                                height: 120,
                                margin: "0 auto",
                                borderRadius: 16,
                                overflow: "hidden",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                            }}
                        >
                            <img
                                src={`https://food.totalfresh.co${slide.data.image}`}
                                alt={slide.data.name}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                }}
                            />
                        </div>
                    );

                    return (
                        <div
                            key={slide.data.id}
                            style={{
                                minWidth: "100%",
                                padding: "24px 28px",
                                boxSizing: "border-box",
                                scrollSnapAlign: "start",
                            }}
                        >
                            {slide.data.model === "3" ? (
                                <a href={slide.url}>{Image}</a>
                            ) : (
                                <NavLink to={`../${slide.url}`}>{Image}</NavLink>
                            )}
                        </div>
                    );
                })}
            </div>

            {/* Dots */}
            <div
                style={{
                    position: "absolute",
                    bottom: 10,
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    gap: 6,
                }}
            >
                {slides.map((_, i) => (
                    <span
                        key={i}
                        style={{
                            width: 5,
                            height: 5,
                            borderRadius: "50%",
                            background: i === currentIndex ? "#333" : "#ccc",
                            transition: "background 0.3s",
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default PromoSlider;
